import React from 'react';

import { SessionManagementService } from '~src/sessionManagement/SessionManagementService';
import { ISitePrivateConnectSettingsForSiteAdmin} from '~src/settings/privateconnect-settings/PrivateConnectSettings';
import {PrivateConnectSettingsCoordinator} from '~src/settings/privateconnect-settings/PrivateConnectSettingsCoordinator';
import {subspaceStyle} from '~src/settings/styles/CommonStyles';
import {Sites} from '~src/siteManagement/services/resources/Sites';
import {SpacesSiteUrls} from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';


interface PrivateConnectSiteSettingsSubspaceOwnProps {
  readonly siteName: string;
  readonly urls: SpacesSiteUrls;
  readonly server: SessionManagementService;
  readonly isSessionMultiSite: boolean;
  readonly isSessionServerAdmin: boolean;
}

export interface PrivateConnectSiteSettingsSubspaceState {
  readonly hasDataToRender: boolean;
  readonly hasError: boolean;
  readonly settings: ISitePrivateConnectSettingsForSiteAdmin;
}

export class PrivateConnectSiteSettingsSubspaceComponent extends React.PureComponent<PrivateConnectSiteSettingsSubspaceOwnProps, PrivateConnectSiteSettingsSubspaceState> {
  private unmounted: boolean = false;
  private sites = Sites.instance;


  private initialState: PrivateConnectSiteSettingsSubspaceState = {
    hasDataToRender: false,
    hasError: false,
    settings: undefined,
  };


  public constructor(props: PrivateConnectSiteSettingsSubspaceOwnProps) {
    super(props);
    this.state = this.initialState;
  }

  public componentDidMount() {
    this.getData();
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  public componentDidUpdate(prevProps: PrivateConnectSiteSettingsSubspaceOwnProps) {
    return;
  }

  public render() {
    return (
      <div className={subspaceStyle}>
        <PrivateConnectSettingsCoordinator {...this.state}/>
      </div>
    );
  }

  private updateState<K extends keyof PrivateConnectSiteSettingsSubspaceState>(newState: Pick<PrivateConnectSiteSettingsSubspaceState, K>, callback?: () => void): void {
    if (!this.unmounted) {
      this.setState(newState, callback);
    }
  }

  private getData = async () => {
    try {
      await this.props.server.getSessionInfoPromise();
    } catch (e) {
      this.updateState({hasError: true});
    }
  };
}